import { render, staticRenderFns } from "./ScoreMain.vue?vue&type=template&id=648c5628&scoped=true"
import script from "./ScoreMain.vue?vue&type=script&lang=js"
export * from "./ScoreMain.vue?vue&type=script&lang=js"
import style0 from "./ScoreMain.vue?vue&type=style&index=0&id=648c5628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c5628",
  null
  
)

export default component.exports